import { useState, useEffect } from 'react';
import { redirectToExternalPage } from '../helpers';

const useWhatsappAvailability = data => {
  const [contactData, setContactData] = useState(null);

  const setData = () => {
    const getAvailabilityMessage = (days, start, finish) => {
      const daysOfWeek = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
      ];
      let startDay;
      let finishDay;

      if (days[0] === '0') {
        [finishDay, startDay] = daysOfWeek;
      } else {
        startDay = daysOfWeek[days[0]];
        finishDay = daysOfWeek[days[days.length - 1]];
      }

      return `${startDay} a ${finishDay} de ${start} a ${finish} hrs.`;
    };

    const isAvailableNow = (days, start, finish) => {
      const now = new Date();

      if (days.indexOf(now.getDay().toString()) === -1) {
        return false;
      }
      const startTimeStamp = Date.parse(`${now.toDateString()} ${start}`);
      const finishTimeStamp = Date.parse(`${now.toDateString()} ${finish}`);

      return (
        now.getTime() >= startTimeStamp && now.getTime() <= finishTimeStamp
      );
    };

    const availabilityData = {
      click: () =>
        redirectToExternalPage(
          `https://api.whatsapp.com/send?phone=${data.phoneNumber}`,
          true
        ),
      enabled:
        data.enabled && isAvailableNow(data.days, data.start, data.finish),
      availabilityMessage: getAvailabilityMessage(
        data.days,
        data.start,
        data.finish
      ),
    };
    setContactData(availabilityData);
  };

  useEffect(() => {
    setData();
  }, []);

  return contactData;
};

export default useWhatsappAvailability;
